import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ae7ef892"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=ae7ef892&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports